import styled, { spacing } from "@rentiohq/web-theme";

// RentMatch wordmark brand hue — a brand asset, intentionally not a theme
// token (mirrors RM_COLORS.brand in the RentMatch scene).
export const RENTMATCH_BRAND_COLOR = "#FF3A59";

// Soft/tinted variants of the brand hue. The solid brand fill read as an
// alert/action; a light tint + brand-colored text keeps it an informational
// status label instead of shouting for attention.
export const RENTMATCH_BRAND_TINT = "rgba(255, 58, 89, 0.12)";
export const RENTMATCH_BRAND_BORDER = "rgba(255, 58, 89, 0.28)";

export const RentMatchPill = styled.button.attrs({ type: "button" })`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid ${RENTMATCH_BRAND_BORDER};
  border-radius: 100px;
  padding: 4px ${spacing("tight")};
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  color: ${RENTMATCH_BRAND_COLOR};
  background-color: ${RENTMATCH_BRAND_TINT};
`;

// No bedroom glyph exists in @rentiohq/web-assets, so render a small inline
// bed icon. Drawn as a thin outline (stroke, no fill) to match the streamline
// style of the other meta icons; inherits the surrounding text color.
export const BedIcon = styled.svg`
  width: 16px;
  height: 16px;
  display: block;
  fill: none;
  stroke: currentColor;
  stroke-width: 1px;
  stroke-linecap: round;
  stroke-linejoin: round;
`;
